<template>
    <v-footer>
        <v-container class="mt-6 custom-max-width">
            <v-row v-if="showFooterFaq">
                <v-col cols="12">
                    <div class="font-weight-bold mb-1" :class="$vuetify.display.mdAndUp?'text-h4':'text-h6'">
                        {{ $t('referrers.Frequently Asked Questions') }}
                    </div>
                </v-col>
                <v-col cols="12">
                    <div class="bg-white px-5 px-md-10 px-lg-10 px-xl-10 py-5 rounded-lg my-4">
                        <div class="d-flex align-center font-weight-bold cursor-pointer" :class="$vuetify.display.mdAndUp?'text-h6':'text-body-2'" @click="changeExpanded(1)">
                            <v-btn variant="text" color="info" size="32" :icon="expanded === 1?'mdi-close':'mdi-plus'" rounded class="text-caption mr-4"></v-btn>
                            {{ $t('referrers.FAQ_Question_1') }}
                        </div>
                        <div class="text-body-1 pl-12 pl-md-12 pl-lg-12 pl-xl-12 pt-4" v-if="expanded === 1">
                            {{ $t('referrers.FAQ_Answer_1') }}
                        </div>
                    </div>
                    <div class="bg-white px-5 px-md-10 px-lg-10 px-xl-10 py-5 rounded-lg my-4">
                        <div class="d-flex align-center font-weight-bold cursor-pointer" :class="$vuetify.display.mdAndUp?'text-h6':'text-body-2'" @click="changeExpanded(2)">
                            <v-btn variant="text" color="info" size="32" :icon="expanded === 2?'mdi-close':'mdi-plus'" rounded class="text-caption mr-4"></v-btn>
                            {{ $t('referrers.FAQ_Question_2') }}
                        </div>
                        <div class="text-body-1 pl-12 pl-md-12 pl-lg-12 pl-xl-12 pt-4" v-if="expanded === 2">
                            {{ $t('referrers.FAQ_Answer_2') }}
                        </div>
                    </div>
                    <div class="bg-white px-5 px-md-10 px-lg-10 px-xl-10 py-5 rounded-lg my-4">
                        <div class="d-flex align-center font-weight-bold cursor-pointer" :class="$vuetify.display.mdAndUp?'text-h6':'text-body-2'" @click="changeExpanded(3)">
                            <v-btn variant="text" color="info" size="32" :icon="expanded === 3?'mdi-close':'mdi-plus'" rounded class="text-caption mr-4"></v-btn>
                            {{ $t('referrers.FAQ_Question_3') }}
                        </div>
                        <div class="text-body-1 pl-12 pl-md-12 pl-lg-12 pl-xl-12 pt-4" v-if="expanded === 3">
                            {{ $t('referrers.FAQ_Answer_3') }}
                        </div>
                    </div>
                    <div class="bg-white px-5 px-md-10 px-lg-10 px-xl-10 py-5 rounded-lg my-4">
                        <div class="d-flex align-center font-weight-bold cursor-pointer" :class="$vuetify.display.mdAndUp?'text-h6':'text-body-2'" @click="changeExpanded(4)">
                            <v-btn variant="text" color="info" size="32" :icon="expanded === 4?'mdi-close':'mdi-plus'" rounded class="text-caption mr-4"></v-btn>
                            {{ $t('referrers.FAQ_Question_4') }}
                        </div>
                        <div class="text-body-1 pl-12 pl-md-12 pl-lg-12 pl-xl-12 pt-4" v-if="expanded === 4">
                            {{ $t('referrers.FAQ_Answer_4') }}
                        </div>
                    </div>
                </v-col>
            </v-row>
            <ImagesCarousel v-if="showFooterGallery"/>
            <div>
               <img :width="100" height="20" src="/img/logo.svg" class="mx-auto mt-5 pt-1"/>
            </div>
            <v-row align="center" class="mx-lg-16 mt-lg-10" no-gutters>
                <v-col cols="12" :class="$vuetify.display.smAndDown?'py-1':''">
                    <v-row no-gutters>
                        <v-col cols="12">
                            <div class="d-flex justify-between">
                                <div>
                                    <span :class="$vuetify.display.mdAndUp?'text-body-1':'text-body-2'" v-html="$t('referrers.Footer_part_1')"></span>
                                </div>
                                <div>
                                    <span :class="$vuetify.display.mdAndUp?'text-body-1':'text-body-2'" v-html="$t('referrers.Footer_part_2')"></span>
                                </div>
                                <div>
                                    <a :href="$t('referrers.TC-link')" target="_blank">{{$t('referrers.TC-label')}}</a> <br/>
                                    <a :href="$t('referrers.PP-link')" target="_blank">{{$t('referrers.PP-label')}}</a>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </v-footer>
</template>

<script>
import {ref} from "vue";
import ReviewsCarousel from "@/Components/Campaigns/ReviewsCarousel.vue";
import ImagesCarousel from "@/Components/Campaigns/ImagesCarousel.vue";

export default {
    name: "Footer",
    components: {ImagesCarousel, ReviewsCarousel},
    data() {
        return {
            expanded: null,
        };
    },
    props: {
        showFooterFaq: {
            type: Boolean,
            default: true
        },
        showFooterGallery: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        changeExpanded(key) {
            if (this.expanded === key) {
                this.closeExpand()
            } else {
                this.expanded = key;
            }
        },
        closeExpand() {
            this.expanded = null;
        }
    },
}
</script>

<style scoped lang="scss">
.custom-max-width {
    @media (min-width: 1280px) {
        max-width: 1200px;
    }
}

.cursor-pointer {
    cursor: pointer;
}
</style>
